<template>
    <div class="relative">
        <input
            :id="uid"
            v-model="inputValue"
            :type="type"
            :disabled="disabled"
            :autocomplete="autocomplete"
            placeholder=" "
            class="app-input block w-full box-border outline-none rounded pt-6 pb-1 px-5 text-normal"
            :class="disabled ? 'bg-white text-gray-400 cursor-default' : 'bg-gray-100'"
            @keydown.enter="$emit('submit')"
        />
        <label
            :for="uid"
            class="app-input-label text-gray-400 absolute left-5 top-4 transition-all text-normal truncate pointer-events-none"
            :class="disabled ? 'opacity-60' : ''"
        >
            {{ label }}
        </label>
        <p v-if="error" class="text-xs text-error-500 mt-0.5 ml-1">{{ error }}</p>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    modelValue: string;
    label?: string;
    type?: string;
    disabled?: boolean;
    error?: string;
    autocomplete?: string;
}>();

const emit = defineEmits<{
    'update:modelValue': [value: string];
    'submit': [];
}>();

const uid = `input-${Math.random().toString(36).substring(6)}`;

const inputValue = computed({
    get: () => props.modelValue,
    set: (val: string) => emit('update:modelValue', val),
});
</script>

<style scoped>
.app-input:focus + .app-input-label,
.app-input:not(:placeholder-shown) + .app-input-label {
    top: 0.4rem !important;
    font-size: 0.8125rem !important;
}
</style>
